import { getFirestore, collection, addDoc, serverTimestamp, getDocs, query, orderBy, limit, where } from 'firebase/firestore';

/**
 * Enterprise Forensic Audit Logger
 * Writes an immutable, tamper-evident record to the tenant's secure audit collection.
 */
export const recordAuditLog = async (tenantId, payload) => {
  if (!tenantId) throw new Error("Tenant ID required for audit logging.");
  const db = getFirestore();
  
  // Generate a client-side SHA-256 hash of the payload for visual integrity verification
  const encoder = new TextEncoder();
  const dataString = JSON.stringify(payload) + Date.now();
  const hashBuffer = await crypto.subtle.digest('SHA-256', encoder.encode(dataString));
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');

  const auditRef = collection(db, `clients/${tenantId}/audit_logs`);
  
  return await addDoc(auditRef, {
    ...payload,
    signature: hashHex,
    timestamp: serverTimestamp()
  });
};

/**
 * Fetch Audit Logs with Smart Filters
 */
export const fetchAuditLogs = async (tenantId, filters = {}) => {
  if (!tenantId) return [];
  const db = getFirestore();
  let q = query(collection(db, `clients/${tenantId}/audit_logs`), orderBy('timestamp', 'desc'), limit(100));

  // Note: For compound filtering in Firestore, ensure composite indexes are built via the Firebase Console
  if (filters.entityType) {
    q = query(q, where('target.entityType', '==', filters.entityType));
  }
  if (filters.actionCategory) {
    q = query(q, where('category', '==', filters.actionCategory));
  }

  const snapshot = await getDocs(q);
  return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
};